import { Injectable, Pipe, PipeTransform } from '@angular/core';
import * as moment from "moment";
import * as momentTz from "moment-timezone";
import * as CryptoJS from 'crypto-js';
import { convertToLocalDate } from '../../modules/shared/helpers/convert-to-local-date.helper';

@Pipe({
    name: 'localDate'
})
@Injectable({
    providedIn: 'root'
  })
export class LocalDatePipe implements PipeTransform {
    encryptSecretKey = "LionO3602.0CRM2021";

    constructor() { }

    decode(data) {
        const decrypted = CryptoJS.AES.decrypt(data, this.encryptSecretKey);
        if (decrypted) {
            try {
                const str = decrypted.toString(CryptoJS.enc.Utf8);
                if (str.length > 0) {
                    return JSON.parse(str);
                } else {
                    return 'error 1';
                }
            } catch (e) {
                return 'error 2';
            }
        }
        return 'error 3';
    }

    transform(date: any, format?: 'date' | 'dateTime' | 'MM-DD-YYYY' | 'MM/DD/YYYY' | 'h:mm a' | 'MM/DD/YYYY | h:mm a' | 'MMMM/YYYY', userZone: boolean = true): any {
        let checkDate = Date.parse(date);
        date = convertToLocalDate(date);
        if (date === '' || date === null || isNaN(checkDate) == true) {
            return '';
        }
        if (format == 'date') {
            format = 'MM/DD/YYYY';
        } else if (format == 'dateTime') {
            format = 'MM/DD/YYYY | h:mm a';
        }

        let dateStr = date + '';
        if (!dateStr.endsWith('Z')) {
            date = date + 'Z';
            dateStr = date;
        }

        const dateFormat = format ? format : 'MM/DD/YYYY | h:mm a';
        let newDate = new Date(date);
        const sessionData = localStorage.getItem('liono360') ? this.decode(localStorage.getItem('liono360')) : null;
        if (sessionData && sessionData.timeZone && userZone) {
            const mDate = momentTz.tz(newDate, sessionData.timeZone.IANATimeZone);
            const timezonedDate = mDate.tz(sessionData.timeZone.IANATimeZone).format(dateFormat)
            return timezonedDate;
        }

        if (dateStr.endsWith('Z')) {
            date = date.replace(/^Z+|Z+$/g, '');
            newDate = new Date(date);
        }

        return moment.parseZone(newDate).format(dateFormat);
    }

    transformDate(date: any, format: string): any {
        let checkDate = Date.parse(date);

        if (date === '' || date === null || isNaN(checkDate) == true) {
            return '';
        }
        if (format == 'date') {
            format = 'MM-DD-YYYY';
        }

        const dateFormat = format ? format : 'MM/DD/YYYY';
        const returnDate = moment(date).format(dateFormat);
        return returnDate;
    }
}
